import {Container, Stack} from "@mui/material";
import React, {useContext} from "react";
import {workAttrList} from "../../workdb/types/workForm";
import Pjdb1RadioGroup from "../../../components/inputs/Pjdb1RadioGroup";
import {
  BASE_WORLD_REGISTER_STEPS,
  CONTEXT_ACTION_TYPE, CUSTOM_WORLD_REGISTER_STEPS,
  DataStoreContext,
  REGISTER_TYPE_LABELS,
  REGISTER_TYPES,
  RegisterPayload,
} from "../contexts/OperatingEnvironmentContext";
import ObjectRegisterStep from "../components/steps/ObjectRegisterStep";
import BaseWorldRegisterModelSelectionStep from "../components/steps/BaseWorldRegisterModelSelectionStep";
import BaseWorldRegisterWorldNameInputStep from "../components/steps/BaseWorldRegisterWorldNameInputStep";
import CustomWorldRegisterSelectionStep from "../components/steps/CustomWorldRegisterSelectionStep";
import CustomWorldRegisterInfoInputStep from "../components/steps/CustomWorldRegisterInfoInputStep";

export default function Register() {
  const {state, dispatch} = useContext(DataStoreContext);

  return (
    <Container maxWidth='lg' sx={{mt: 2}}>
      <Stack gap={4}>
        <Pjdb1RadioGroup
          name={workAttrList.modelType.key}
          value={state.register.type}
          onChange={(event) => {
            dispatch({
                type: CONTEXT_ACTION_TYPE.REGISTER,
                payload: {type: event.target.value} satisfies RegisterPayload
              }
            );
          }}
          radios={Object.values(REGISTER_TYPES).map((btnKey) => ({btnKey, btnLbl: REGISTER_TYPE_LABELS[btnKey]}))}
        />
        {state.register.type === REGISTER_TYPES.OBJECT && <ObjectRegisterStep/>}
        {state.register.type === REGISTER_TYPES.BASE_WORLD && <BaseWorldRegister/>}
        {state.register.type === REGISTER_TYPES.CUSTOM_WORLD && <CustomWorldRegister/>}
      </Stack>
    </Container>
  );
}

function BaseWorldRegister() {
  const {state} = useContext(DataStoreContext);

  if (state.baseWorldRegister.step === BASE_WORLD_REGISTER_STEPS.WORLD_NAME_INPUT_STEP) {
    return <BaseWorldRegisterWorldNameInputStep/>;
  }

  return (<BaseWorldRegisterModelSelectionStep/>);
}

function CustomWorldRegister() {
  const {state} = useContext(DataStoreContext);

  if (state.customWorldRegister.step === CUSTOM_WORLD_REGISTER_STEPS.WORLD_INFO_INPUT_STEP) {
    return <CustomWorldRegisterInfoInputStep/>;
  }

  return (<CustomWorldRegisterSelectionStep/>);
}
